<template>
  <form>
    <div class="category-top-bar" ref="optionsTopBar">
      <div class="top-bar">
       <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="cancelOption">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
       </p>
       <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="!isNew()" @click.prevent="handleDeleteOption" style="padding: 7px 10px; margin-right: 20px;margin-bottom: 0;">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-icon btn-success btn mar-rt-10 save" style="margin-bottom: 0;"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div class="row mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="col-lg-12 col-md-12">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="card-content" v-if="model">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="row">
              <!-- Coloana Stanga - Informatii de baza -->
              <div class="col-md-4">
                <h5 class="section-title">{{ $t('catalogProdOpt.generalInformation') }}</h5>

                <div class="form-group">
                  <label class="form-label">{{$t('catalogProdOpt.name')}}</label>
                  <input type="text"
                            :placeholder="$t('catalogProdOpt.name')"
                            class="form-control"
                            v-model="model.name"
                            v-validate="modelValidate.required">
                </div>

                <div class="form-group">
                  <label class="form-label">{{$t('catalogProdOpt.label')}}</label>
                  <input type="text"
                          :placeholder="$t('catalogProdOpt.label')"
                          class="form-control"
                          v-model="model.label">
                </div>

                <div class="form-group">
                  <label class="form-label">{{$t('catalogProdOpt.type')}}</label>
                  <select v-model="model.type" class="form-control">
                    <option v-for="(opt, key) in optionTypes" :value="key">{{opt}}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label class="form-label">{{$t('catalogProdOpt.show_type')}}</label>
                  <select v-model="model.show_type" class="form-control">
                    <option v-for="(opt, key) in showTypes" :value="key">{{opt}}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label class="form-label">{{$t('catalogProdOpt.show_type_kiosk')}}</label>
                  <select v-model="model.show_type_kiosk" class="form-control">
                    <option v-for="(opt, key) in showTypesKiosk" :value="key">{{opt}}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label class="form-label">{{$t('catalogProdOpt.variants_id')}}</label>
                  <input type="text"
                          :placeholder="$t('catalogProdOpt.variants_id')"
                          class="form-control"
                          v-model="model.variants_id">
                </div>
              </div>

              <!-- Coloana Mijloc - Setari si Disponibilitate -->
              <div class="col-md-4">
                <h5 class="section-title">{{ $t('catalogProdOpt.settings') }}</h5>

                <div class="form-group" v-if="showLocations">
                  <label class="form-label">{{$t('catalogProd.availableInLocation')}}</label>
                  <v-select v-model="optionLocationDetails"
                              multiple
                              :options="locations"
                               value="id"
                              label="name"
                              :ref="'model' + model.id"
                              :placeholder="$t('general.all')"
                              class=""
                              :key="'model' + model.id">
                  </v-select>
                </div>

                <div class="form-group">
                  <label class="form-label">{{$t('catalogProd.availableFor')}}</label>
                  <v-select v-model="optionDeliveryMethods"
                              multiple
                              :options="deliveryMethods"
                              :placeholder="$t('general.all')">
                  </v-select>
                </div>

                <div class="form-group">
                  <label class="form-label">{{$t('catalogProd.availableForSource')}}</label>
                  <v-select v-model="optionSources"
                              multiple
                              :options="sourceOptions"
                              :placeholder="$t('general.all')">
                  </v-select>
                </div>

                <div class="form-group" style="margin-bottom: 35px; background: #fff;  padding: 10px; border: 1px solid #e8e8e8;">
                  <label class="form-label">{{$t('catalogProdOpt.optionType')}}</label>
                  <div class="radio-group">
                    <p-radio
                      v-model="model.is_product"
                      name="is_product"
                      :value="1"
                      :label="1"
                      :inline="true"
                      style="margin: 0;"
                    >
                      {{$t('catalogProdOpt.isProduct')}}
                    </p-radio>
                    <small class="help-text">{{$t('catalogProdOpt.isProductDesc')}}</small>

                    <p-radio
                      v-model="model.is_product"
                      name="is_product"
                      :value="0"
                      :label="0"
                      :inline="true"
                      style="margin: 0;"
                    >
                      {{$t('catalogProdOpt.isModifier2')}}
                    </p-radio>
                    <small class="help-text">{{$t('catalogProdOpt.isModifierDesc')}}</small>
                  </div>
                </div>

                <div class="checkbox-group row">
                  <div class="col-md-4">
                    <div class="form-group checkbox-item">
                      <label class="form-label">{{$t('catalogProdOpt.isModifier')}}</label>
                      <p-checkbox
                        v-model="model.is_modifier"
                        class="text-purple"
                        :value="model.is_modifier">
                      </p-checkbox>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group checkbox-item">
                      <label class="form-label">{{$t('catalogProdOpt.menuQr')}}</label>
                      <p-checkbox
                        v-model="model.display_in_dynamic_menu"
                        class="text-purple"
                        :value="model.display_in_dynamic_menu"
                        :label="$t('displayInMenu')">
                      </p-checkbox>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group checkbox-item">
                      <label class="form-label">{{$t('settingLocationGroups.active')}}</label>
                      <p-checkbox
                        v-model="model.active"
                        class="text-purple"
                        :value="model.active"
                        :label="$t('settingLocationGroups.active')">
                      </p-checkbox>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Coloana Dreapta - Imagine -->
              <div class="col-md-4">
                <h5 class="section-title">{{ $t('catalogProd.image') }}</h5>
                <div class="form-group image-upload-group">
                  <label class="form-label">{{$t('catalogProd.image')}}</label>
                    <el-upload
                      action=""
                      ref="upload"
                      :limit="2"
                      :file-list="model.image"
                      list-type="picture-card"
                      accept=" .jpg, .jpeg, .png"
                      :on-change="handleImgChnage1"
                      :on-exceed="handleExceed"
                      :on-remove="handleRemove1"
                      :auto-upload="false">
                      <img src="/static/img/icons/icon-plus-primary.png">
                      <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                    </el-upload>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== VALORI OPTIUNI - 3 COLOANE ===== -->
    <div class="row mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="col-lg-12 col-md-12">
        <div class="card mar-to-15" v-if="optionValuesData">
          <div class="card-header">
            <h5 class="section-title" style="margin: 0;">{{ $t('catalogProdOpt.values') }}</h5>
          </div>
          <div class="card-content values-section">

            <div v-for="(item, index) in optionValuesData" :key="'value-' + index"
                 class="value-row"
                 v-if="!item.hasOwnProperty('delete') || (item.hasOwnProperty('delete') && item.delete != 1)">

              <!-- COLOANA 1: Date (Nume, POS, TVA, Sectie, Cantitate) -->
              <div class="value-col value-col-data">

                <!-- ID deasupra numelui -->
                <div class="item-id-badge" v-if="item.id">
                  <span class="id-label">ID: {{ item.id }}</span>
                </div>

                <div class="form-group">
                  <label class="small-label">{{$t('catalogProdOpt.option_name')}} #{{index+1}}</label>
                  <input type="text"
                          class="form-control"
                          v-model="item.name"
                          v-validate="modelValidate.required">
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="small-label">{{$t('catalogProdOpt.sgrName')}}</label>
                      <input type="text"
                              class="form-control sml"
                              v-model="item.name_sgr">
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="small-label">{{$t('catalogProdOpt.sgrPrice')}}</label>
                      <input type="text"
                              class="form-control sml"
                              v-model="item.price_sgr">
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="small-label">{{$t('catalogProdOpt.sgrPos')}}</label>
                      <input type="text"
                              class="form-control sml"
                              v-model="item.pos_id_sgr">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="small-label">{{$t('catalogProdOpt.posid')}}</label>
                      <input type="text"
                              class="form-control sml"
                              v-model="item.pos_id">
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="small-label">{{$t('catalogProdOpt.posid2')}}</label>
                      <input type="text"
                              class="form-control sml"
                              v-model="item.external_id">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="small-label">{{$t('catalogProdOpt.vat')}}</label>
                      <select v-if="taxesVersion === 2" v-model="item.vat_rate_id" class="form-control sml">
                        <option :value="null">{{ $t('vat.selectVat') }}</option>
                        <option v-for="vat in vatOptions" :key="vat.id" :value="vat.id" :disabled="isVatOptionDisabled(vat, item.vat_rate_id)">{{ vat.rate }}%{{ !vat.is_active ? ' (inactiv)' : '' }}</option>
                      </select>
                      <select v-else v-model="item.vat_id" class="form-control sml">
                        <option value="0">{{ $t('vat.selectVat') }}</option>
                        <option v-for="vat in vatOptions" :key="vat.id" :value="vat.id">{{ vat.amount }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="small-label">{{$t('catalogProdOpt.vatSGR')}}</label>
                      <select v-if="taxesVersion === 2" v-model="item.vat_rate_id_sgr" class="form-control sml">
                        <option :value="null">{{ $t('vat.selectVat') }}</option>
                        <option v-for="vat in vatOptions" :key="vat.id" :value="vat.id" :disabled="isVatOptionDisabled(vat, item.vat_rate_id_sgr)">{{ vat.rate }}%{{ !vat.is_active ? ' (inactiv)' : '' }}</option>
                      </select>
                      <select v-else v-model="item.vat_id_sgr" class="form-control sml">
                        <option value="null">{{ $t('vat.selectVat') }}</option>
                        <option v-for="vat in vatOptions" :key="vat.id" :value="vat.id">{{ vat.amount }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="small-label">{{$t('catalogProdOpt.section')}}</label>
                      <select v-model="item.section_id" class="form-control sml">
                        <option :value="null">{{ $t('general.select') }} {{ $t('catalogProdOpt.section') }}</option>
                        <option v-for="section in kdsSectionsParent" :value="section.id" :label="section.name" :key="section.id"></option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="small-label">{{$t('printer.section')}} SGR</label>
                      <select v-model="item.sgr_section_id" class="form-control sml">
                        <option :value="null">{{ $t('printer.section') }} SGR</option>
                        <option v-for="section in kdsSectionsParent" :value="section.id" :label="section.name" :key="section.id"></option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- Cantitate -->
                <div class="quantity-block">
                  <div class="form-group checkbox-item-inline">
                    <label class="small-label">{{$t('companyOptions.allowQuantity')}}</label>
                    <p-checkbox
                      v-model="item.allow_quantity"
                      class="text-purple"
                      :value="1">
                    </p-checkbox>
                  </div>

                  <div v-if="item.allow_quantity == 1" class="quantity-inputs-row">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="small-label">{{$t('companyOptions.minQuantity')}}</label>
                          <input type="number"
                                  class="form-control sml"
                                  min="1"
                                  max="9999"
                                  oninput="
                                   if(this.value.length > 4) this.value = this.value.slice(0,4);
                                   if(this.value !== '' && this.value < 1) this.value = 1;
                                 "
                                  v-model.number="item.min_quantity">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="small-label">{{$t('companyOptions.maxQuantity')}}</label>
                          <input type="number"
                                  class="form-control sml"
                                  min="1"
                                  max="9999"
                                  oninput="
                                   if(this.value.length > 4) this.value = this.value.slice(0,4);
                                   if(this.value !== '' && this.value < 1) this.value = 1;
                                 "
                                  v-model.number="item.max_quantity">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <!-- COLOANA 2: Descriere si Produs -->
              <div class="value-col value-col-desc">
                <div class="form-group">
                  <label class="small-label">{{$t('catalogProdOpt.info')}}</label>
                  <div class="wysiwyg-wrapper">
                    <wysiwyg v-model="item.cov_info" :placeholder="$t('catalogProdOpt.infoPlaceholder')"/>
                  </div>
                </div>

                <div class="form-group inline-field">
                  <label class="small-label">{{$t('companyOptions.print_with_product_label')}}</label>
                  <p-switch v-model="item.print_with_product_label" type="success"></p-switch>
                </div>

                <div class="form-group">
                  <label class="small-label">{{$t('companyOptions.product_id')}}</label>
                  <el-select
                    v-model="item.product_id"
                    filterable
                    remote
                    reserve-keyword
                    clearable
                    :remote-method="searchProducts"
                    :loading="searchProductsLoading"
                    :loading-text="$t('general.generalLoader')"
                    style="width: 100%;"
                    :placeholder="$t('general.add')"
                    :no-data-text="$t('general.no_data')"
                  >
                    <el-option
                      v-for="prod in allProducts"
                      :key="prod.id"
                      :value="prod.id"
                      :label="prod.name"
                    />
                    <el-option
                      v-for="hiddenItem in allProductsHidden"
                      :key="'hidden-' + hiddenItem.id"
                      :value="hiddenItem.id"
                      :label="hiddenItem.name"
                      class="hidden-option"
                    />
                    <template>
                      <span v-if="!searchProductsLoading && allProducts.length === 0"
                        style="padding: 0; margin: 0; text-align: center; color: #999; font-size: 14px; width: 100%; display: inline-block;">
                        {{ $t('general.no_data') }}
                      </span>
                    </template>
                  </el-select>
                </div>
              </div>

              <!-- COLOANA 3: Poze -->
              <div class="value-col value-col-images">
                <div class="images-row">
                  <div class="image-upload-wrapper">
                    <label class="small-label">{{$t('catalogProdOpt.image')}}</label>
                    <el-upload
                      action=""
                      ref="upload"
                      :limit="2"
                      :file-list="item.image ? item.image : []"
                      list-type="picture-card"
                      accept=" .jpg, .jpeg, .png"
                      :on-change="(file,fileList) => { return handleImgChnage(file,fileList,index) }"
                      :on-exceed="handleExceed"
                      :on-remove="(file,fileList) => { return handleRemove(file,fileList,index) }"
                      :auto-upload="false">
                      <img src="/static/img/icons/icon-plus-primary.png">
                    </el-upload>
                  </div>
                  <div class="image-upload-wrapper">
                    <label class="small-label">{{$t('companyOptions.prod_image')}}</label>
                    <el-upload
                      action=""
                      ref="upload"
                      :limit="2"
                      :file-list="item.prod_image ? item.prod_image : []"
                      list-type="picture-card"
                      accept=" .jpg, .jpeg, .png"
                      :on-change="(file,fileList) => { return handleImgProdChnage(file,fileList,index) }"
                      :on-exceed="handleExceed"
                      :on-remove="(file,fileList) => { return handleRemoveProd(file,fileList,index) }"
                      :auto-upload="false">
                      <img src="/static/img/icons/icon-plus-primary.png">
                    </el-upload>
                  </div>
                </div>
              </div>

              <!-- BARA ACTIUNI - pe toata latimea -->
              <div class="value-actions-bar">
                <div class="actions-left">
                  <div class="form-group checkbox-item-inline" style="margin: 0;">
                    <label class="small-label">{{$t('catalogProdOpt.active')}}</label>
                    <p-switch v-model="item.active" type="success"></p-switch>
                  </div>
                </div>
                <div class="actions-right">
                  <button class="btn btn-simple btn-icon delete-btn" @click.prevent="deleteValue(index)">
                    <i :title="$t('general.delete')" class="ti-close text-orange"></i>
                    <span>{{$t('general.delete')}}</span>
                  </button>
                </div>
              </div>

            </div>

            <button class="btn add mar-to-15 mar-lt-20" @click.prevent="addNewValue()">
              <img src="/static/img/icons/add.png">
              {{$t('catalogProdOpt.addNewOptionValue')}} #{{optionValuesData.length + 1}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="space_for_alert_box" style="height: 100px; width: 100%;"></div>
  </form>
</template>
<script>
  /* eslint-disable */
  import Vue from 'vue'
  import {Input, Upload, Button, DatePicker} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import swal from 'sweetalert2'
  import draggable from 'vuedraggable'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)

  export default {
    components: {
      PSwitch,
      draggable,
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      },
      tableId: null,
      callback: {
        required: false
      },
      kdsSectionsParent: {
        type: Array,
        required: true
      }
    },
    watch: {
      tableId (value) {
        this.id = value
      }
    },
    async created () {
      this.apiUrl = process.env.API_BASE_URL
      this.deliveryMethods = this.getCompanyDetail('delivery_options_labels')

      let companyData = this.$session.get('selectedCompanyData')
      this.locations = companyData.locations_details
      // Afișăm mereu selectorul de locație, chiar și cu o singură locație,
      // ca să poată fi văzute/curățate legături rămase orfane (ex. opțiune legată
      // de o locație care între timp a fost ștearsă).
      this.showLocations = true

      await this.getData()
    },
    data () {
      return {
        apiUrl: '',
        roles: [],
        allProducts: [],
        allProductsHidden: [],
        selectedIdsForProducts: [],
        searchTimeout: null,
        searchProductsLoading: false,
        deletedOptionValues: [],
        vatOptions: [],
        taxesVersion: Number((this.$session.get('selectedCompanyData') || {}).taxes_version || 1),
        id: this.value || this.tableId,
        showLocations: false,
        locations: [],
        optionValuesData: null,
        optionTypes: {
          'checkbox': this.$t('checkbox'),
          'radio': this.$t('radio'),
          'upload': this.$t('productOptions.upload')
        },
        showTypes: {
          null: 'Default',
          'grid': 'Grid',
          'inline': 'In linie'
        },
        showTypesKiosk: {
          null: 'Default',
          'default': 'Default with images',
          'steps': 'In Steps'
        },
        model: false,
        modelValidate: {
          name: {required: true},
          type: {required: true},
          status: {required: true}
        },
        languages: this.$session.get('defaultData')['available_languages'],
        loading: true,
        deliveryMethods: [],
        optionDeliveryMethods: [],
        initialOptionDeliveryMethods: [],
        optionLocationDetails: [],
        initialOptionLocationDetails: [],
        sourceOptions: [
          { key: 'website', label: 'Website' },
          { key: 'qr', label: 'QR' },
          { key: 'kiosk', label: 'Kiosk' },
          { key: 'pos', label: 'POS' },
          { key: 'app', label: 'App' },
          { key: 'glovo', label: 'Glovo' },
          { key: 'bolt', label: 'Bolt' },
          { key: 'wolt', label: 'Wolt' }
        ],
        optionSources: [],
        initialOptionSources: []
      }
    },
    methods: {
      getVatOptions (locaitonIds) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_ids: locaitonIds
        }
        const endpoint = this.taxesVersion === 2 ? '/taxes-v2/vat-rates' : '/location/vat'
        this.apiRequest(endpoint, 'GET', data, (response) => {
          if (response.status === true) {
            this.vatOptions = response.data
          }
        })
      },
      isVatOptionDisabled (vat, selectedId) {
        return !!(this.taxesVersion === 2 && vat && !vat.is_active && String(vat.id) !== String(selectedId))
      },
      searchProducts (query) {
        this.searchProductsLoading = true
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout)
        }
        this.searchTimeout = setTimeout(() => {
          this.fetchProducts(query)
        }, 1000)
      },
      async fetchProducts (searchText = '') {
        return new Promise((resolve, reject) => {
          this.selectedIdsForProducts = []
          this.optionValuesData.forEach(el => {
            if (el.product_id) {
              this.selectedIdsForProducts.push(el.product_id)
            }
          })
          this.searchProductsLoading = true
          var data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            search: searchText,
            selected_ids: this.selectedIdsForProducts
          }
          this.apiRequest('/get-products-for-options', 'GET', data, (response) => {
            this.searchProductsLoading = false
            if (response.status === true) {
              this.allProducts = response.data.products
              this.allProductsHidden = response.data.selected_products
              resolve(response)
            } else {
              reject(new Error('Eroare la încărcare produse'))
            }
          })
        })
      },
      async principalData () {
        return new Promise((resolve, reject) => {
          var data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          if (!this.isNew()) {
            var id = this.route.params.id || this.id
            this.apiRequest('/get-company-option/' + id, 'GET', data, (response) => {
              if (response.status === true) {
                this.model = response.data.option
                this.optionValuesData = response.data.option_value

                // Procesează câmpurile de cantitate - folosim 1/0 pentru p-checkbox
                this.optionValuesData.forEach((item, idx) => {
                  // Asigurăm că allow_quantity e 1 sau 0 (nu true/false)
                  const allowQty = item.allow_quantity == 1 ? 1 : 0
                  Vue.set(this.optionValuesData[idx], 'allow_quantity', allowQty)

                  // Setăm min/max ca number sau null, limitat la 9999
                  const minQty = item.min_quantity !== null && item.min_quantity !== undefined && item.min_quantity !== ''
                    ? Math.min(parseInt(item.min_quantity), 9999)
                    : null
                  const maxQty = item.max_quantity !== null && item.max_quantity !== undefined && item.max_quantity !== ''
                    ? Math.min(parseInt(item.max_quantity), 9999)
                    : null

                  Vue.set(this.optionValuesData[idx], 'min_quantity', minQty)
                  Vue.set(this.optionValuesData[idx], 'max_quantity', maxQty)
                })

                this.optionDeliveryMethods = response.data.delivery_methods
                this.initialOptionDeliveryMethods = this.copyVar(this.optionDeliveryMethods)

                this.optionLocationDetails = response.data.location_details
                this.initialOptionLocationDetails = this.copyVar(this.optionLocationDetails)

                this.optionSources = response.data.sources || []
                this.initialOptionSources = this.copyVar(this.optionSources)

                this.selectedIdsForProducts = []
                this.optionValuesData.forEach(el => {
                  if (el.product_id) {
                    this.selectedIdsForProducts.push(el.product_id)
                  }
                })
                resolve(true)
              } else {
                reject(new Error('Eroare la încărcare company-option'))
              }
            })
          } else {
            this.model = {
              'id': null,
              'active': true,
              'image': [],
              'prod_image': [],
              'location_ids': '',
              'type': 'checkbox',
              'is_product': 0,
              'is_modifier': 0,
              'name': ''
            }
            this.optionValuesData = []
            this.addNewValue()
            resolve(true)
          }
        })
      },
      async getData () {
        this.loading = true
        try {
          await Promise.all([
            this.getVatOptions()
          ])
          await this.principalData()
          await Promise.all([
            this.fetchProducts(null)
          ])
        } catch (error) {
          console.error('❌ Eroare:', error)
        } finally {
          this.loading = false
        }
      },
      isNew () {
        if (this.route.params.id) {
          return false
        } else {
          return true
        }
      },
      validateProductIds () {
        if (!this.model.is_product) return true
        const invalidItems = this.optionValuesData.filter((item, index) => {
          if (item.delete === 1) return false
          return !item.product_id || item.product_id === ''
        })
        return invalidItems.length === 0
      },
      validateQuantities () {
        const invalidItems = this.optionValuesData.filter((item, index) => {
          // Ignoră item-urile marcate pentru ștergere
          if (item.delete === 1) return false
          // Verifică doar dacă allow_quantity e activat
          if (item.allow_quantity != 1) return false

          const min = item.min_quantity !== null && item.min_quantity !== '' ? parseInt(item.min_quantity) : null
          const max = item.max_quantity !== null && item.max_quantity !== '' ? parseInt(item.max_quantity) : null

          // Dacă ambele sunt completate, min nu poate fi mai mare ca max
          if (min !== null && max !== null && min > max) {
            return true
          }
          return false
        })
        return invalidItems.length === 0
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          const productIdsValid = this.validateProductIds()
          if (!productIdsValid) {
            swal({
              text: this.$t('catalogProdOpt.productIdRequired'),
              type: 'error',
              showConfirmButton: true
            })
            return
          }

          const quantitiesValid = this.validateQuantities()
          if (!quantitiesValid) {
            swal({
              text: this.$t('companyOptions.quantityMinMaxError'),
              type: 'error',
              showConfirmButton: true
            })
            return
          }

          if (isValid && productIdsValid && quantitiesValid) {
            this.saveOption()
          }
        })
      },
      handleErrors (errors) {
        swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
      },
      prepareOptionValuesForSave () {
        return this.optionValuesData.map(item => {
          let preparedItem = { ...item }

          if (this.taxesVersion === 2) {
            delete preparedItem.vat_id
            delete preparedItem.vat_id_sgr
          } else {
            delete preparedItem.vat_rate_id
            delete preparedItem.vat_rate_id_sgr
          }

          // allow_quantity ramane 1 sau 0
          if (!preparedItem.allow_quantity || preparedItem.allow_quantity == 0) {
            preparedItem.allow_quantity = 0
            preparedItem.min_quantity = null
            preparedItem.max_quantity = null
          } else {
            preparedItem.allow_quantity = 1
            preparedItem.min_quantity = preparedItem.min_quantity !== '' && preparedItem.min_quantity !== undefined && preparedItem.min_quantity !== null
              ? Math.min(parseInt(preparedItem.min_quantity), 9999)
              : null
            preparedItem.max_quantity = preparedItem.max_quantity !== '' && preparedItem.max_quantity !== undefined && preparedItem.max_quantity !== null
              ? Math.min(parseInt(preparedItem.max_quantity), 9999)
              : null
          }

          return preparedItem
        })
      },
      saveOption () {
        this.loading = true
        let id = this.route.params.id || 0
        let data = {}
        var companyID = this.$session.get('selectedCompany')
        data.token = this.$session.get('token')
        data.company_id = companyID
        data.option = this.model

        data.option_value = this.prepareOptionValuesForSave()

        delete data.option.location_ids

        let optionDeliveryMethodsToCreate = this.optionDeliveryMethods.filter(obj2 => !this.initialOptionDeliveryMethods.find(obj1 => obj1.key === obj2.key))
        let optionDeliveryMethodsToDelete = this.initialOptionDeliveryMethods.filter(obj2 => !this.optionDeliveryMethods.find(obj1 => obj1.key === obj2.key))

        if (optionDeliveryMethodsToCreate) {
          data.option_delivery_methods_to_create = optionDeliveryMethodsToCreate
        }

        if (optionDeliveryMethodsToDelete) {
          data.option_delivery_methods_to_delete = optionDeliveryMethodsToDelete
        }

        let optionLocationDetailsToCreate = this.optionLocationDetails.filter(obj2 => obj2.true_id && !this.initialOptionLocationDetails.find(obj1 => obj1.location_id === obj2.true_id))
        let optionLocationDetailsToDelete = this.initialOptionLocationDetails.filter(obj2 => !this.optionLocationDetails.find(obj1 => (
          (obj1.true_id && obj1.true_id === obj2.location_id) || (obj1.location_id && obj1.location_id === obj2.location_id)
        )))

        if (optionLocationDetailsToCreate) {
          data.option_location_details_to_create = optionLocationDetailsToCreate
        }

        if (optionLocationDetailsToDelete) {
          data.option_location_details_to_delete = optionLocationDetailsToDelete
        }

        let optionSourcesToCreate = this.optionSources.filter(obj2 => !this.initialOptionSources.find(obj1 => obj1.key === obj2.key))
        let optionSourcesToDelete = this.initialOptionSources.filter(obj2 => !this.optionSources.find(obj1 => obj1.key === obj2.key))

        if (optionSourcesToCreate) {
          data.option_sources_to_create = optionSourcesToCreate
        }

        if (optionSourcesToDelete) {
          data.option_sources_to_delete = optionSourcesToDelete
        }

        this.apiRequest('/save-option/' + id, 'PUT', data, (response) => {
          if (response.status === true) {
            this.loading = false
            this.errors.clear()
            swal({'text': this.$t('menuLink.updated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            this.cancelOption()
          } else {
            this.loading = false
            this.handleErrors(response.errors)
          }
        })
      },
      addNewValue () {
        let newRow = {
          'id': null,
          'name': '',
          'pos_id': null,
          'vat_id': null,
          'vat_rate_id': null,
          'vat_rate_id_sgr': null,
          'active': true,
          'allow_quantity': 0,
          'min_quantity': null,
          'max_quantity': null
        }

        this.optionValuesData.push(newRow)
      },
      deleteValue (index) {
        Vue.set(this.optionValuesData[index], 'delete', 1)
        swal({'text': this.$t('companyOptions.deleteVal'), 'type': 'success', 'showConfirmButton': false, 'timer': 5000}).then(() => {}).catch(() => {})
      },
      deleteOption () {
        this.loading = true
        var id = this.id || this.route.params.id
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/delete-option/' + id, 'PUT', data, (response) => {
          if (response.status === true) {
            this.trackAdminEvent('ADMIN_COMPANY_OPTION_DELETED', 'company_option', id, {
              company_option_id: id,
              name: (this.model && this.model.name) || null
            })
            this.loading = false
            swal({'text': 'Deleted succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).then(() => {}).catch(() => {})
            this.cancelOption()
          } else {
            this.loading = false
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
        })
      },
      handleImgChnage1 (file, fileList) {
        let pp = this.model
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          this.$refs.upload.clearFiles()
          pp.image = []
        } else {
          if (fileList.length > 1) {
            pp.image = fileList.slice(1)
          } else {
            pp.image = fileList
          }
        }
        this.model = null
        this.model = pp
        this.getBase64(this.model.image[0].raw).then((base64enc) => {
          this.model.image[0].base64enc = base64enc
        })
      },
      handleRemove1 (file, fileList) {
        if (fileList.length === 0) {
          this.model.image = []
        }
      },
      handleImgChnage (file, fileList, index) {
        const self = this
        let pp = this.optionValuesData
        const isOkSize = file.size / 1024 / 1024 < 5
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          self.$refs.upload.clearFiles()
          pp[index].image = []
        } else {
          if (fileList.length > 1) {
            pp[index].image = fileList.slice(1)
          } else {
            pp[index].image = fileList
          }
        }
        this.optionValuesData = null
        this.optionValuesData = pp
        this.getBase64(this.optionValuesData[index].image[0].raw).then((base64enc) => {
          this.optionValuesData[index].image[0].base64enc = base64enc
        })
      },
      handleImgProdChnage (file, fileList, index) {
        const self = this
        let pp = this.optionValuesData
        const isOkSize = file.size / 1024 / 1024 < 5
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          self.$refs.upload.clearFiles()
          pp[index].prod_image = []
        } else {
          if (fileList.length > 1) {
            pp[index].prod_image = fileList.slice(1)
          } else {
            pp[index].prod_image = fileList
          }
        }
        this.optionValuesData = null
        this.optionValuesData = pp
        this.getBase64(this.optionValuesData[index].prod_image[0].raw).then((base64enc) => {
          this.optionValuesData[index].prod_image[0].base64enc = base64enc
        })
      },
      handleExceed (files, fileList) {
        swal({
          text: this.$t('general.removePhoto'),
          type: 'warning',
          showConfirmButton: true
        })
      },
      handleRemove (file, fileList, index) {
        if (fileList.length === 0) {
          this.optionValuesData[index].image = []
        }
      },
      handleRemoveProd (file, fileList, index) {
        if (fileList.length === 0) {
          this.optionValuesData[index].prod_image = []
        }
      },
      handleDeleteOption () {
        var btnCounter = 3
        var self = this
        swal({
          text: this.$t('companyOptions.deleteQues'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            self.deleteOption()
          }
        })
        swal.disableConfirmButton()

        var btnInterval = setInterval(function () {
          btnCounter--
          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')'
          } else {
            swal.getConfirmButton().textContent = self.$t('general.yes')
            clearInterval(btnInterval)
            swal.enableConfirmButton()
          }
        }, 1000)
      },
      cancelOption () {
        if (this.route.path && this.route.path.includes('/integrations/menu-fix')) {
          window.close()
          return
        }
        // this.router.push('/product-options')
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>
<style>
  .hidden-option {
    display: none !important;
  }
  .copy_link {
    margin-top: 10px;
    width: 100%;
  }
  .upload-demo input[type="file"]{ display: none; }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  /* ===== STILURI SUS - FORM PRINCIPAL ===== */

  .section-title {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 2px solid #e8e8e8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .form-label {
    font-size: 12px;
    font-weight: 600;
    color: #555;
    margin-bottom: 6px;
    display: block;
  }

  .small-label {
    font-size: 11px;
    font-weight: 600;
    color: #666;
    margin-bottom: 4px;
    display: block;
  }

  .radio-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .radio-group p-radio {
    margin-bottom: 2px;
  }

  .help-text {
    font-size: 11px;
    color: #888;
    margin-left: 24px;
    margin-top: -4px;
    margin-bottom: 8px;
    display: block;
  }

  .checkbox-group {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #eee;
  }

  .checkbox-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .image-upload-group {
    text-align: center;
  }

  .image-upload-group .el-upload--picture-card {
    margin: 0 auto;
  }

  /* ===== STILURI VALORI - 3 COLOANE ===== */

  .values-section {
    padding: 20px;
  }

  .value-row {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
    padding: 20px 20px 0 20px;
    margin-bottom: 0;
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
    position: relative;
  }

  .value-row + .value-row {
    margin-top: 20px;
  }

  .value-row:hover {
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  }

  .value-col {
    display: flex;
    flex-direction: column;
    padding: 0 15px;
  }

  /* Coloana 1: Date */
  .value-col-data {
    flex: 0 0 40%;
    max-width: 40%;
    padding-right: 20px;
    border-right: 1px solid #f0f0f0;
  }

  /* Coloana 2: Descriere */
  .value-col-desc {
    flex: 0 0 35%;
    max-width: 35%;
    padding-left: 20px;
    padding-right: 20px;
    border-right: 1px solid #f0f0f0;
  }

  /* Coloana 3: Poze */
  .value-col-images {
    flex: 0 0 25%;
    max-width: 25%;
    padding-left: 20px;
  }

  /* ID Badge */
  .item-id-badge {
    margin-bottom: 10px;
  }

  .id-label {
    display: inline-block;
    background: #667eea;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 12px;
    border-radius: 12px;
    letter-spacing: 0.5px;
  }

  /* Checkbox inline */
  .checkbox-item-inline {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .checkbox-item-inline .small-label {
    margin-bottom: 0;
  }

  /* Cantitate */
  .quantity-block {
    background: #f8f9fa;
    padding: 12px 15px;
    border-radius: 6px;
    margin-top: 10px;
    border: 1px solid #e8e8e8;
  }

  .quantity-inputs-row {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #ccc;
  }

  /* ===== BARA ACTIUNI - PE TOATA LATIMEA ===== */
  .value-actions-bar {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 20px;
    margin: 15px -20px 0 -20px;
    background: #f8f9fa;
    border-top: 2px solid #e8e8e8;
    border-radius: 0 0 8px 8px;
  }

  .actions-left {
    display: flex;
    align-items: center;
  }

  .actions-right {
    display: flex;
    align-items: center;
  }

  .delete-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    border-radius: 6px;
    transition: all 0.2s;
    border: 1px solid #ffcdd2;
    background: #ffebee;
    color: #c62828;
    font-size: 12px;
    font-weight: 500;
  }

  .delete-btn:hover {
    background: #ffcdd2;
    border-color: #ef9a9a;
  }

  .delete-btn i {
    font-size: 14px;
  }

  /* WYSIWYG */
  .wysiwyg-wrapper {
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    min-height: 150px;
  }

  .inline-field {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
  }

  .inline-field .small-label {
    margin-bottom: 0;
  }

  /* Poze */
  .images-row {
    display: flex;
    flex-direction: column;
    gap: 15px;
    height: 100%;
  }

  .image-upload-wrapper {
    flex: 1;
  }

  .image-upload-wrapper .el-upload--picture-card {
    width: 120px;
    height: 120px;
    line-height: 120px;
  }

  /* Card header */
  .card-header {
    padding: 15px 20px;
    background: #f8f9fa;
    border-bottom: 1px solid #e8e8e8;
  }

  /* Inputuri mici */
  .form-control.sml {
    font-size: 12px;
    padding: 6px 10px;
    height: 32px;
  }

  .text-right {
    text-align: right;
  }

  /* Responsive */
  @media (max-width: 1200px) {
    .value-row {
      flex-direction: column;
    }

    .value-col-data,
    .value-col-desc,
    .value-col-images {
      flex: 1 1 100%;
      max-width: 100%;
      border-right: none;
      border-bottom: 1px solid #f0f0f0;
      padding: 15px 0;
    }

    .value-col-images {
      border-bottom: none;
    }

    .images-row {
      flex-direction: row;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ProductOptions/ProductOptionsForm.vue